export { getRuntimeConfig } from './getRuntimeConfig';
